const DEFAULT_VIEW = "overview";

export const navigationViews = new Set([
  "overview",
  "today",
  "work-blocks",
  "people",
  "tasks",
  "events",
  "admin",
]);

export const navigationDrawerTypes = new Set([
  "work-block",
  "person",
  "task",
]);

function locationUrl(locationLike) {
  const pathname = locationLike?.pathname || "/";
  const search = locationLike?.search || "";
  const hash = locationLike?.hash || "";
  return new URL(`${pathname}${search}${hash}`, "http://local.manager");
}

export function readNavigationState(locationLike) {
  const url = locationUrl(locationLike);
  const requestedView = url.searchParams.get("page");
  const view = navigationViews.has(requestedView)
    ? requestedView
    : DEFAULT_VIEW;
  const detailType = url.searchParams.get("detail");
  const detailId = url.searchParams.get("item");
  const drawer = navigationDrawerTypes.has(detailType) && detailId
    ? { type: detailType, id: detailId }
    : null;

  return { view, drawer };
}

export function navigationUrl(locationLike, { view, drawer }) {
  const url = locationUrl(locationLike);

  if (navigationViews.has(view) && view !== DEFAULT_VIEW) {
    url.searchParams.set("page", view);
  } else {
    url.searchParams.delete("page");
  }

  if (drawer && navigationDrawerTypes.has(drawer.type) && drawer.id) {
    url.searchParams.set("detail", drawer.type);
    url.searchParams.set("item", drawer.id);
  } else {
    url.searchParams.delete("detail");
    url.searchParams.delete("item");
  }

  return `${url.pathname}${url.search}${url.hash}`;
}

export function removeSearchParameter(locationLike, parameter) {
  const url = locationUrl(locationLike);
  url.searchParams.delete(parameter);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function currentReturnTo(locationLike) {
  const url = locationUrl(locationLike);
  url.searchParams.delete("auth_error");
  return `${url.pathname}${url.search}${url.hash}`;
}
